<template>
  <div class="@container box-border min-h-0 min-w-0">
    <div
      class="box-border grid h-full min-h-0 w-full grid-cols-3 grid-rows-3 gap-[13%] rounded-[25%] bg-surf-brand-base-def p-[18cqi]"
    >
      <div />
      <div class="h-full w-full rounded-full animate-logo-bg-fade" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade-delay-500" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade-delay-500" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade-delay-1000" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade-delay-500" />
      <div class="h-full w-full rounded-full animate-logo-bg-fade-delay-1000" />
    </div>
  </div>
</template>

<style scoped>
@keyframes logo-bg-fade {
  0% {
    background-color: var(--color-white);
  }
  32.258065% {
    background-color: transparent;
  }
  64.516129%,
  100% {
    background-color: var(--color-white);
  }
}

@keyframes logo-bg-fade-shift-500 {
  0%,
  16.129032% {
    background-color: var(--color-white);
  }
  48.387097% {
    background-color: transparent;
  }
  80.645161%,
  100% {
    background-color: var(--color-white);
  }
}

@keyframes logo-bg-fade-shift-1000 {
  0%,
  32.258065% {
    background-color: var(--color-white);
  }
  64.516129% {
    background-color: transparent;
  }
  96.774194%,
  100% {
    background-color: var(--color-white);
  }
}

.animate-logo-bg-fade {
  animation: logo-bg-fade 2.583333s ease-in-out infinite;
}

.animate-logo-bg-fade-delay-500 {
  animation: logo-bg-fade-shift-500 2.583333s ease-in-out infinite;
}

.animate-logo-bg-fade-delay-1000 {
  animation: logo-bg-fade-shift-1000 2.583333s ease-in-out infinite;
}
</style>
